import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { BookOpen, Download, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function Help() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/pilot_guide.md')
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((text) => {
        setContent(text);
        setLoading(false);
      })
      .catch((e) => {
        setError(e.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-6" data-testid="help-page">
      <div className="flex items-start justify-between mb-6 pb-4 border-b">
        <div className="flex items-center gap-3">
          <BookOpen className="h-6 w-6 text-red-600" />
          <div>
            <h1 className="text-2xl font-semibold">Manual de Utilização</h1>
            <p className="text-sm text-muted-foreground">
              Guia completo para administradores em modo ensaio
            </p>
          </div>
        </div>
        <a href="/pilot_guide.md" download="ChaviarteStockFlow-Manual.md">
          <Button variant="outline" size="sm" data-testid="help-download-btn">
            <Download className="h-4 w-4 mr-2" />
            Descarregar
          </Button>
        </a>
      </div>

      {loading && (
        <div className="flex items-center gap-2 text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin" />
          A carregar manual...
        </div>
      )}

      {error && (
        <div className="text-red-600 bg-red-50 border border-red-200 rounded p-4">
          Falha a carregar manual: {error}
        </div>
      )}

      {!loading && !error && (
        <article
          className="prose prose-slate max-w-none
            prose-headings:font-semibold prose-headings:scroll-mt-20
            prose-h1:text-3xl prose-h1:mt-0
            prose-h2:text-2xl prose-h2:mt-10 prose-h2:pb-2 prose-h2:border-b
            prose-h3:text-lg prose-h3:mt-6
            prose-table:text-sm
            prose-th:bg-slate-50 prose-th:font-semibold prose-th:px-3 prose-th:py-2 prose-th:text-left
            prose-td:px-3 prose-td:py-2 prose-td:border-t prose-td:border-slate-100
            prose-code:bg-slate-100 prose-code:px-1.5 prose-code:py-0.5 prose-code:rounded prose-code:text-red-700 prose-code:text-sm prose-code:before:content-none prose-code:after:content-none
            prose-a:text-red-600 prose-a:no-underline hover:prose-a:underline
            prose-li:my-1
            prose-blockquote:border-red-300 prose-blockquote:bg-red-50 prose-blockquote:py-1 prose-blockquote:px-4 prose-blockquote:not-italic
          "
          data-testid="help-content"
        >
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </article>
      )}
    </div>
  );
}
